"use strict";
var search_1 = require("./search");
var searchsuggest_1 = require("./searchsuggest");
var site_1 = require("./site");
var webs_1 = require("./webs");
var util_1 = require("../../utils/util");
var userprofiles_1 = require("./userprofiles");
var Rest = (function () {
    function Rest() {
    }
    Rest.prototype.searchSuggest = function (query) {
        var finalQuery;
        if (typeof query === "string") {
            finalQuery = { querytext: query };
        }
        else {
            finalQuery = query;
        }
        return new searchsuggest_1.SearchSuggest("").execute(finalQuery);
    };
    Rest.prototype.search = function (query) {
        var finalQuery;
        if (typeof query === "string") {
            finalQuery = { Querytext: query };
        }
        else {
            finalQuery = query;
        }
        return new search_1.Search("").execute(finalQuery);
    };
    Object.defineProperty(Rest.prototype, "site", {
        get: function () {
            return new site_1.Site("");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rest.prototype, "web", {
        get: function () {
            return new webs_1.Web("");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rest.prototype, "profiles", {
        get: function () {
            return new userprofiles_1.UserProfileQuery("");
        },
        enumerable: true,
        configurable: true
    });
    Rest.prototype.createBatch = function () {
        return this.web.createBatch();
    };
    Rest.prototype.crossDomainSite = function (addInWebUrl, hostWebUrl) {
        return this._cdImpl(site_1.Site, addInWebUrl, hostWebUrl, "site");
    };
    Rest.prototype.crossDomainWeb = function (addInWebUrl, hostWebUrl) {
        return this._cdImpl(webs_1.Web, addInWebUrl, hostWebUrl, "web");
    };
    Rest.prototype._cdImpl = function (factory, addInWebUrl, hostWebUrl, urlPart) {
        if (!util_1.Util.isUrlAbsolute(addInWebUrl)) {
            throw "The addInWebUrl parameter must be an absolute url.";
        }
        if (!util_1.Util.isUrlAbsolute(hostWebUrl)) {
            throw "The hostWebUrl parameter must be an absolute url.";
        }
        var url = util_1.Util.combinePaths(addInWebUrl, "_api/SP.AppContextSite(@target)");
        var instance = new factory(url, urlPart);
        instance.query.add("@target", "'" + encodeURIComponent(hostWebUrl) + "'");
        return instance;
    };
    return Rest;
}());
exports.Rest = Rest;
